module.exports = {"description":"","methods":[],"displayName":"MksSiteFooter","comment":"","tags":{},"events":{},"slots":{"default":{"description":""}}}